import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-puntos-venta',
  templateUrl: './puntos-venta.component.html',
  styleUrls: ['./puntos-venta.component.scss']
})
export class PuntosVentaComponent implements OnInit {

  private itemsCol:    AngularFirestoreCollection<any>;
  public  items:       Observable<any>;
  public  item;
  public  dataSource = new MatTableDataSource<any>();
  public  fnReviewTotalRecargas;

  public displayedColumns = ["idpos", "punto", "ruta", "circuito", "cliente", "celular", "telefono", "totalRecargas", "totalBonificacion", "pagoInicial", "totalPagos", "pendiente"/*, "options"*/ ];
  //"barrio", "direccion", "latitud", "longitud"
  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator; 
  filter: string = "";

  constructor(
    private afFirestore: AngularFirestore,
    private snackBar: MatSnackBar,
    private afFunctions: AngularFireFunctions,) {    
    
  }

  ngOnInit() {    
    this.fnReviewTotalRecargas = this.afFunctions.httpsCallable('reviewTotalRecargas');
    this.itemsCol              = this.afFirestore.collection<any>("punto-venta"/*, ref=>ref.limit(100)*/);
    this.items                 = this.itemsCol.valueChanges();
    this.items.subscribe(
      data => {
        this.dataSource = new MatTableDataSource<any>(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter; 
      }
    );
  }

  trackByUid(index, item) {
    return item.uid;
  }

  showComisions(item){
    this.item = item;
  }

  showList(){
    this.item = null;
  }

  applyFilter(filterValue: string) {  
    this.dataSource.filter = filterValue;     
  }

  showDelete(item){
    if(confirm("¿Esta seguro de querer eliminar a este punto de venta?")){
      var itemRef = this.itemsCol.doc(""+item.idpos).ref;
      itemRef.delete()
        .then(
          ()=>{
            this.showList();
          }
        )
        .catch(
          (error)=>{
            this.snackBar.open("Error inesperado eliminando el punto de venta","Entiendo",{duration: 2000});
          }
        );
    }
  }

  reviewTotalRecargas(item){
    if(confirm("¿Esta seguro de querer recalcular el  de regargas?\n\n Es posible que el proceso tarde un rato,\n debe mantenerse en esta pagina aunque no se muestre una barra de progreso.")){
      this.fnReviewTotalRecargas(""+item.idpos)
      .toPromise()
      .then(
        (totalRecargas) => {        
          if( confirm("Se ha calculado un total de "+totalRecargas+"\n\n ¿Quiere actualizar el punto de venta?") ){
            var itemRef = this.itemsCol.doc(""+item.idpos).ref;
            itemRef.set({'totalRecargas':totalRecargas}, { merge: true })
              .then(
                ()=>{
                  this.snackBar.open("Se ha actualizado el punto de venta","Entiendo",{duration: 2000});
                  this.showList();
                }
              )
              .catch(
                (error)=>{
                  this.snackBar.open("Error inesperado actualizando el punto de venta, intente nuevamente","Entiendo",{duration: 2000});
                }
              );  
          }
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado eliminando el usuario","Entiendo",{duration: 2000});
        }
      );      
    }
  }

  checkNull(value){
    return (value != null && value != undefined ? value : 0);
  }

}
